import Image from "next/image";
import WhiteLogoColors from "@/public/images/white-logo-colors.png";
import BlackLogo from "@/public/images/black-logo.png";

export default function Logo() {
  return (
    <span className="inline-flex w-[120px] items-center min-[360px]:w-[148px] sm:w-[180px] lg:w-[200px]">
      <Image src={BlackLogo} alt="Techno Music World" width={200} quality={90} priority className="h-auto w-full dark:hidden" />
      <Image src={WhiteLogoColors} alt="Techno Music World" width={200} quality={90} priority className="hidden h-auto w-full dark:block" />
    </span>
  );
}
